import React, { FC } from 'react';
import ReviewStar from './svg/ReviewStar';
import EmptyReviewStar from './svg/EmptyReviewStar';

interface Props {
    average: number;
}

const getStar = (value: boolean) => {
    switch (value) {
        case true:
            return <ReviewStar />;
        default:
            return <EmptyReviewStar />;
    }
};

const getStars = (value: number) => {
    const stars = Math.round((value / 10) * 5);
    return new Array(5).fill(null).map((_, i) => i < stars);
};

const ReviewStars: FC<React.PropsWithChildren<Props>> = ({ average }) => (
    <>{getStars(average).map(item => getStar(item))}</>
);

export default ReviewStars;
